import { render } from "./LoginPage.vue?vue&type=template&id=5b0358cd&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=5b0358cd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b0358cd"

export default script